import { action, computed, makeObservable } from "mobx";
import type { FlowTemplateData } from "../../templates/generator/types";
import type { Api } from "../core/apis";
import { BaseModel, type BaseModelData } from "../core/BaseModel";
import type { Stores } from "../core/stores";
import type { PlanInfoProps } from "../plans/PlanInfoBox";

export interface PlansTemplateModelData extends BaseModelData {
  editHash: string; // uuid to identify edit page

  createdAt: number;
  timesUsed: number;
  template: FlowTemplateData;
}

export default class PlansTemplateModel extends BaseModel<PlansTemplateModelData> {
  constructor(stores: Stores, api: Api, data: PlansTemplateModelData) {
    super(stores, api, data);

    makeObservable(this);
  }

  public async setTemplateData(data: Partial<FlowTemplateData>) {
    this.data.template = { ...this.data.template, ...data };
    await this.api.templatesApi.set(this);
  }

  @action public async bumpUsedStats() {
    this.data.timesUsed++;
    await this.api.templatesApi.set(this);
  }

  @computed get planInfoProps(): PlanInfoProps {
    return {
      descriptionYooptaEditor:
        this.data.template.descriptionYooptaEditor ?? null,
      coverUrl: this.data.template.coverUrl ?? null,
      backgroundColor: this.data.template.backgroundColor ?? null,
      emoji: this.data.template.emoji ?? null,
      title: this.data.template.title ?? null,
    };
  }

  toFireStore(): Omit<PlansTemplateModelData, "uid"> {
    const data: Omit<PlansTemplateModelData, "uid"> = {
      ...this.fromBaseModel(),
      ...this.data,
    };

    return data;
  }
}
